import { FaChurch, FaCalendarAlt, FaUsers, FaMapMarkerAlt, FaChartLine } from 'react-icons/fa';

const Header = ({ title }) => (
  <div className="mb-8">
    <div className="flex items-center justify-between bg-gradient-to-r from-blue-600 via-indigo-700 to-purple-800 rounded-2xl p-6 shadow-lg">
      <div className="flex items-center space-x-4">
        <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center">
          <FaChurch className="text-white text-xl" />
        </div>
        <div>
          <h1 className="text-2xl lg:text-3xl font-bold text-white">{title}</h1>
          <p className="text-blue-100">Welcome back, manage your church network</p>
        </div>
      </div>
      
    </div>
  </div>
);

export default Header;